export default {
  addRole: '添加角色',
  id: 'ID',
  role: '角色',
  actions: '操作',
  edit: '编辑',
  delete: '删除',
  addRoleTitle: '添加角色',
  editRoleTitle: '编辑角色',
  roleName: '角色名称',
  roleNamePlaceholder: '请输入角色名称',
  rolePermissions: '角色权限',
  cancel: '取消',
  confirm: '确定',
  level1Menu: '一级菜单',
  level2Menu: '二级菜单',
  confirmDelete: '确定删除该角色',
};
